export class Manager {
  constructor(
    public email: string,
    public lastname: string,
    public firstname: string,
    public gender: { id: number },
    public profile: { id: number },
    public roles: { id: number; roleName?: string; libelle?: string },
    public country?: { id: number; name?: string },
    public city?: { id: number },
    public phoneNumberOne?: string,
    public phoneNumberTwo?: string,
    public active?: boolean,
    public createdAt?: any,
    public iuf?: string,
    public structure?: string,
  ) {}
}
